'use strict';

export class StickyHelper {
	constructor() {
		this.$stickies = jQuery('.js-sticky_container');
	}
	
	init() {
		this.$stickies.each((index, sticky_element) => {
			const $sticky = jQuery(sticky_element);
			if (this.already_initialized($sticky)) {
				return;
			}
			$sticky.data('initialized', true);
			const $target = jQuery('<div class="js-sticky_observe"></div>');
			$sticky.after($target);
			const element = $target[0];
			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					$sticky.toggleClass('stuck', !entry.isIntersecting);
				});
			}, {
				threshold: 0
			});
			observer.observe(element);
		})
	}
	already_initialized($sticky) {
		return $sticky.data('initialized');
	}
}